export default "__VITE_ASSET__MPYpQs0b__"